import { typesRedux } from '../../shared/types/typesRedux';

const initialState = {
    mode: '',
    logUser: undefined,
};

export const generalReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case typesRedux.MODE_THEME:
            return {
                ...state,
                mode: action.payload,
            };

        case typesRedux.USER_LOG:
            return {
                ...state,
                logUser: { ...action.payload },
            };

        case typesRedux.LOGOUT_LOGIN:
            return {
                ...state,
                logUser: undefined,
            };

        default:
            return state;
    }
};
